import {BlogCategory, BlogIndexPage, BlogPage, NewsletterSubscription, NewsletterConfirmData, NewsletterCancelData} from '../models';

export class LoadIndex {
  static readonly type = '[Blog] Load Index';
  constructor() { }
}

export class LoadIndexSuccess {
  static readonly type = '[Blog] Load Index Success';
  constructor(public indexPage: BlogIndexPage) {}
}

export class LoadIndexFail {
  static readonly type = '[Blog] Load Index Fail';
  constructor(public err: any) {}
}

export class LoadEntry {
  static readonly type = '[Blog] Load Entry';
  constructor(public slug: string) {}
}

export class LoadEntrySuccess {
  static readonly type = '[Blog] Load Entry Success';
  constructor(public url: string, public entry: BlogPage) {}
}

export class LoadEntryFail {
  static readonly type = '[Blog] Load Entry Fail';
  constructor(public url: string, public err: any) {}
}

export class LoadList {
  static readonly type = '[Blog] Load List';
  constructor(public name: string, public value: string) {}
}

export class LoadListSuccess {
  static readonly type = '[Blog] Load List Success';
  constructor(public url: string, public entries: BlogPage[]) {}
}

export class LoadListFail {
  static readonly type = '[Blog] Load List Fail';
  constructor(public url: string, public err: any) {}
}

export class LoadCategory {
  static readonly type = '[Blog] Load LoadCategory';
  constructor(public name: string) {}
}

export class LoadCategorySuccess {
  static readonly type = '[Blog] Load LoadCategory Success';
  constructor(public category: BlogCategory) {}
}

export class LoadSubscription {
  static readonly type = '[Blog] Load Subscription';
  constructor() {}
}

export class LoadSubscriptionSuccess {
  static readonly type = '[Blog] Load Subscription Success';
  constructor(public subscription: NewsletterSubscription) {}
}

export class GetSubscriptionByID {
  static readonly type = '[Blog] Get Subscription By ID';
  constructor(public subscriptionID: number) {}
}

export class SendSubscription {
  static readonly type = '[Blog] Send Subscription';
  constructor() {}
}

export class SendSubscriptionSuccess {
  static readonly type = '[Blog] Send Subscription Success';
  constructor(public subscription: NewsletterSubscription) {}
}

export class ConfirmSubscription {
  static readonly type = '[Blog] Confirm Subscription';
  constructor(public confirmationData: NewsletterConfirmData) {}
}

export class ConfirmSubscriptionSuccess {
  static readonly type = '[Blog] Confirm Subscription Success';
  constructor(public subscription: NewsletterSubscription) {}
}

export class CancelSubscription {
  static readonly type = '[Blog] Cancel Subscription';
  constructor(public cancellationData: NewsletterCancelData) {}
}

export class CancelSubscriptionSuccess {
  static readonly type = '[Blog] Cancel Subscription Success';
  constructor(public subscription: NewsletterSubscription) {}
}

export class UpdateSubscription {
  static readonly type = '[Blog] Update Subscription';
  constructor(public updateData: any) {}
}
